// frontend/src/components/ServiceWorkerUpdateBanner.js
// "A newer version of TALIT has finished loading in the background —
// refresh to use it." Shown whenever serviceWorkerRegistration.js detects
// a newly-installed worker waiting to take over (see its own header for
// why activation is never automatic: this app deploys multiple times a
// day, and silently swapping a tab's running JS out from under a cashier
// mid-sale is its own real problem).
import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useServiceWorkerUpdate } from '../hooks/useServiceWorkerUpdate';

export default function ServiceWorkerUpdateBanner() {
  const { updateAvailable, applyUpdate } = useServiceWorkerUpdate();
  if (!updateAvailable) return null;

  return (
    <div className="w-full text-sm flex items-center justify-between gap-3 px-4 py-2 bg-indigo-600 text-white">
      <span className="flex items-center gap-2">
        <RefreshCw className="w-4 h-4 shrink-0" />
        A newer version of TALIT is ready.
      </span>
      <button
        onClick={applyUpdate}
        className="shrink-0 inline-flex items-center gap-1 bg-white/15 hover:bg-white/25 rounded px-3 py-1 text-xs font-medium"
      >
        Refresh now
      </button>
    </div>
  );
}
